import { Model } from './model';
import { Fabbricato } from './fabbricato';

export class TipologiaCostruttiva extends Model {
  static apiUrl: string = "tipologie_costruttive";

  nome: string;
  descrizione: string;
  fabbricati: Fabbricato[];

  deserialize(input: any): TipologiaCostruttiva {
    let retV: TipologiaCostruttiva = new TipologiaCostruttiva();

    retV = super.deserialize(input) as TipologiaCostruttiva;

    if (input?.fabbricati) {
      retV.fabbricati = input.fabbricati.map(m => new Fabbricato().deserialize(m));
    }

    return retV;
  }

}
